<div class="upper-grid">
    <div class="flex justify-content-end">{{ 'voucher.situationORP.dependencyLevel.label' | translate }}:</div>
    <app-radio-input [form]="form" id="dependencyLevel" [staticOptions]="dependencyLevelOptions"
        [autoSelectFirst]="true"
        class="fr-2"></app-radio-input>

    <div class="flex justify-content-end">{{ 'voucher.situationORP.mobilityLevel.label' | translate }}:</div>
    <app-radio-input [form]="form" id="mobilityLevel" [staticOptions]="mobilityOptions"
        [autoSelectFirst]="true"></app-radio-input>
    <app-text-input [form]="form" id="mobilityDescription"
        label="voucher.situationORP.mobilityLevel.description"></app-text-input>

    <div class="flex justify-content-end">{{ 'voucher.situationORP.sensoryDisability' | translate }}:</div>
    <app-radio-yes-no-input [form]="form" id="sensoryDisability"></app-radio-yes-no-input>
    <app-text-input [form]="form" id="sensoryDisabilityDescription"
        label="voucher.situationORP.sensoryDisability"></app-text-input>

    <div class="flex justify-content-end">{{ 'voucher.situationORP.selfCareLevel.label' | translate }}:</div>
    <app-radio-input [form]="form" id="selfCareLevel" [staticOptions]="selfServiceAbilityOptions"
        [autoSelectFirst]="true"></app-radio-input>
    <app-text-input [form]="form" id="selfCareDescription"
        label="voucher.situationORP.selfCareLevel.description"></app-text-input>
</div>
<div class="bottom-grid mt-5">
    <div>{{ 'voucher.situationORP.medicationInformation' | translate }}:</div>
    <div>{{ 'voucher.situationORP.foodServing' | translate }}:</div>

    <div class="flex-column gap">
        <app-input-wysiwyg
            [form]="form"
            id="medicationInformation"
            editorKey="VoucherDetailSituationORPMedicationInformation"
            [height]="300"
        ></app-input-wysiwyg>
        @if (folderStore.canEdit()) {
            <app-button styleClass="w-full" label="voucher.situationORP.addMedication"
                (clickEvent)="addMedication()"></app-button>
        }
    </div>
    <app-input-wysiwyg
        [form]="form"
        id="foodServing"
        editorKey="VoucherDetailSituationORPFoodServing"
        [height]="300"
    ></app-input-wysiwyg>

    <div>{{ 'voucher.situationORP.otherInformation' | translate }}:</div>
    <div>{{ 'voucher.situationORP.goal' | translate }}:</div>

    <app-input-wysiwyg
        [form]="form"
        id="otherInformation"
        editorKey="VoucherDetailSituationORPOtherInformation"
        [height]="340"
    ></app-input-wysiwyg>
    <div class="flex-column gap">
        <app-input-wysiwyg
            [form]="form"
            id="goal"
            editorKey="VoucherDetailSituationORPGoal"
            [height]="300"
        ></app-input-wysiwyg>
        @if (folderStore.canEdit()) {
            <app-button styleClass="w-full" label="voucher.situationORP.addDiagnosis"
                (clickEvent)="addDiagnosis()"></app-button>
        }
    </div>
</div>

<ng-template #placeholderTemplate>
    {{ 'voucher.messages.noContacts' | translate }}
</ng-template>
